module.exports = __webpack_public_path__ + "static/img/case6.b52a48bb.jpg";